export default {
  expiresSoon: 'Dostęp do "{appName}"   zostanie dezaktywowany po {expiryDate}.',
};
